import Glide from '@glidejs/glide'
import { Autoplay } from '@glidejs/glide/dist/glide.modular.esm'

export const slider_review = () => {
  var carousel = document.getElementById('slider-reviews');
  if ( carousel ) {
    var glide = new Glide('#slider-reviews', {
      type: 'carousel',
      perView: 3,
      rewind: false,
      keyboard: true,
      animationDuration: 1200,
      gap: '35px',
      breakpoints: {
        1600: {
          perView: 3,
        },
        900: {
          perView: 2
        },
        600: {
          perView: 2
        },
        480: {
          perView: 1,
        }
      }
    });
    glide.mount()
  }
}

export const slider_gallery = () => {
  var carousel = document.getElementById('slider-gallery');
  if ( carousel ) {
    var glide = new Glide('#slider-gallery', {
      type: 'carousel',
      perView:2 ,
      rewind: false,
      autoplay: 5000,
      keyboard: true,
      animationDuration: 1200,
      gap: '35px',
      breakpoints: {
        1600: {
          perView: 2,
        },
        800: {
          perView: 2
        },
        600: {
          perView: 2
        },
        480: {
          perView: 1,
        }
      }
    });
    glide.mount({ Autoplay })
  }
}
